import Vue from 'vue';
import Vuex from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import account, { types as accountTypes } from './modules/account';
import cart, {
  getters as cartGetters,
  types as cartTypes,
} from './modules/cart';
import categories, {
  getters as categoriesGetters,
  types as categoriesTypes,
} from './modules/categories';
import header, {
  getters as headerGetters,
  types as headerTypes,
} from './modules/header';
import home, { types as homeTypes } from './modules/home';
import menu, { types as menuTypes } from './modules/menu';
import navigation, { types as navigationTypes } from './modules/navigation';
import product, { types as productTypes } from './modules/product';
import productList, {
  getters as productListGetters,
  types as productListTypes,
} from './modules/productList';
import productCustomizer, {
  getters as productCustomizerGetters,
  types as productCustomizerTypes,
} from './modules/productCustomizer';
import search, {
  getters as searchGetters,
  types as searchTypes,
} from './modules/search';
import createPersistence from '../plugins/vuex-session';

export const storeOptions = {
  modules: {
    account,
    cart,
    categories,
    header,
    home,
    menu,
    navigation,
    product,
    productList,
    productCustomizer,
    search,
  },
  getters: {
    addToCartUrl: (state) => state.product.details.addToCartUrl,

    /**
     * Retrieve available product data from product list by productId,
     * (1)(curried function to allow pass param productId to getter)
     * (2)(deep clone to avoid pass object by reference)
     * */
    availableProductDataInPLP: (state) => (productId) => {
      const newObj = state.productList.products
        .flatMap((categoryResults) => categoryResults.items)
        .reduce((acc, ele) => {
          // Avoid any processing if the product was already found
          if (!acc.product.id) {
            // Check normal products
            if (!ele.product?.banner && ele.product?.id === productId) {
              return { ...acc, ...ele };
            }
            // Check slider banner products
            if (ele.product?.banner?.productSlider?.length > 0) {
              const sliderProduct = ele.product.banner.productSlider
                .find((item) => item.id === productId);
              if (sliderProduct) return { ...acc, ...sliderProduct };
            }
          }
          return acc;
        }, { product: {} });

      return cloneDeep(newObj);
    },
    getStateForSession: (state) => ({
      columnMode: state.productList.ui.columnMode,
    }),
  },
  mutations: {
    rehydrateFromSession: (state, backup) => {
      if (backup?.columnMode) {
        // eslint-disable-next-line no-param-reassign
        state.productList.ui.columnMode = backup.columnMode;
      }
    },
  },
  plugins: [createPersistence({
    shouldPersist: (mutationType) => productListTypes.setColumnMode === mutationType,
  })],
};

export const getters = {
  categories: categoriesGetters,
  cart: cartGetters,
  header: headerGetters,
  productCustomizer: productCustomizerGetters,
  productList: productListGetters,
  search: searchGetters,
};

export const types = {
  account: accountTypes,
  cart: cartTypes,
  categories: categoriesTypes,
  header: headerTypes,
  home: homeTypes,
  menu: menuTypes,
  navigation: navigationTypes,
  product: productTypes,
  productList: productListTypes,
  productCustomizer: productCustomizerTypes,
  search: searchTypes,
};

Vue.use(Vuex);
export default new Vuex.Store(storeOptions);
